import { keyframes } from 'styled-components'

import { NextModalStyles } from '../../components/modals/NextModal'

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

export const fadeUpAndIn = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

export const videoModalStyles: NextModalStyles = {
  content: {
    background: 'transparent',
    borderRadius: 0,
    borderWidth: 0,
    bottom: 0,
    left: 0,
    padding: 0,
    right: 0,
    top: 0,
  },
  overlay: {
    backgroundColor: 'intentionally invalid',
  },
}

export const navModalStyles: NextModalStyles = videoModalStyles
